import { useQuery, gql } from '@apollo/client';

const fabricDataQuery = gql`
query FabricData{
  ourFabrics {
   fabricTitle
   fabricDetails{
    fabricImageUrl
    fabricImageAltText
    fabricType
    fabricDescription
    shopAllLabel
    shopAllUrl
    brand
    isSelect
    scaleData{
      scaleType
      currentMeasurement
      minLabelForScale
      maxLabelForScale
      attributeLevel
    }
   }
  } 
}
`;

const useOurFabrics = (isOpen) => {
  const { loading, error, data } = useQuery(fabricDataQuery, {
    skip: !isOpen, // Skip the query if the modal is not open
  });

  return { loading, error, data };
};

export default useOurFabrics;
